export const iconFontAwesomeEmojiFaceFlushed = (
	<i className="fa-solid fa-face-flushed"></i>
);
